import { userProgramService } from "@/api/services/user-program.service";
import { queryOptions } from "@tanstack/react-query";
import { createServerFn } from "@tanstack/react-start";
import { authMiddlewareServer } from "../middleware/auth";

// Get user's active program
export const getActiveUserProgramFn = createServerFn({ method: "GET" })
  .middleware([authMiddlewareServer])
  .handler(async ({ context }) => {
    const userProgram = await userProgramService.getUserActiveProgram(
      context.auth.userId,
    );

    if (!userProgram) {
      return {
        status: 404,
        body: { message: "Aktif program bulunamadı" },
      };
    }

    return {
      status: 200,
      body: userProgram,
    };
  });

export const getActiveUserProgramOptions = () =>
  queryOptions({
    queryKey: ["activeUserProgram"],
    queryFn: () => getActiveUserProgramFn(),
    staleTime: 1000 * 60 * 5,
  });

// Get all user programs
export const getUserProgramsFn = createServerFn({ method: "GET" })
  .middleware([authMiddlewareServer])
  .handler(async ({ context }) => {
    const programs = await userProgramService.getUserPrograms(
      context.auth.userId,
    );

    return {
      status: 200,
      body: {
        programs,
        total: programs.length,
      },
    };
  });

export const getUserProgramsOptions = () =>
  queryOptions({
    queryKey: ["userPrograms"],
    queryFn: () => getUserProgramsFn(),
    staleTime: 1000 * 60 * 5,
  });
